<template>
  <div class="onls-select-course__container">
    <div :class="['onls-select-course', { 'onls-select-course--filled': selectedTitle }]" @click="isOpen = !isOpen">
      <div class="onls-select-course__value">
        <span :class="[selectedTitle ? 'color-primary' : 'color-secondary']">{{ selectedTitle ? selectedTitle : placeholder }}</span>

        <div v-if="!!selectedTitle" class="onls-datepicker__clear" @click.stop="emits('update:value', null)">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"></path></svg>
        </div>
      </div>

      <div v-if="isOpen" class="onls-select-course__options">
        <div
          v-for="(item, i) in courses"
          :key="i"
          class="onls-select-course__options-item"
          @click="selectCourse(item)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>

    <div class="onls-select-course__mobile">
      <filter-icon @click="onFilterClick"/>

      <select name="course" ref="mobileSelect" @change="onFilterClick">
        <option value=""/>

        <option
          v-for="(item, i) in courses"
          :key="i"
          :value="item.course_id"
          :selected="item.course_id === value"
        > {{ item.title }}</option>
      </select>
    </div>
  </div>

</template>

<script setup lang="ts">
import {ref, type PropType, computed} from "vue";
import { FilterIcon } from "../index";

const props = defineProps({
  courses: { type: Array as PropType<Array<{course_id: number; title: string }>>, required: true },
  placeholder: { type: String, default: 'Select course' },
  value: { type: [String, Number], required: true }
});

const emits = defineEmits(['update:value']);

const mobileSelect = ref();

const isOpen = ref(false);

const selectCourse = (item: any) => {
  emits('update:value', item.course_id);
};

const selectedTitle = computed(() => {
  const item = (props.courses || []).find((item) => item.course_id === props.value);

  return item ? item.title : undefined;
});

const onFilterClick = ($event: any) => {
  emits('update:value', $event.target.value);
}
</script>

<style lang="scss">
.onls-select-course {
  width: 100%;
  border: 2px solid var(--secondary-text);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  cursor: pointer;
  position: absolute;
  z-index: 999;
  background: var(--primary-background);

  &__container {
    position: relative;
    height: 53px;
    width: 250px;
  }

  &__value {
    color: var(--secondary-text);
    font-size: 16px;
    padding: 15px 20px;
  }

  &--filled {
    border-color: var(--primary-text);
  }

  &__options {
    &-item {
      padding: 15px 20px;
      color: var(--primary-text);
      font-size: 16px;

      &:hover {
        background: var(--secondary-background);
      }
    }
  }

  &__mobile {
    display: none;
    position: relative;
    width: 20px;
    height: 18px;

    select {
      position: absolute;
      opacity: 0;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    option {
      width: 300px;
      font-size: 16px;
    }
  }

  @media screen and (max-width: 768px) {
    display: none;

    &__container {
      width: auto;
      height: auto;
    }

    &__mobile {
      display: block;
    }
  }
}
</style>
